"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FocusTrap_1 = require("@oui/core/FocusTrap");
var react_remove_scroll_1 = require("react-remove-scroll");
var Messages = require("../../codegen/Messages");
var __1 = require("../../");
var Aria_1 = require("../../resources/Aria");
var util_1 = require("../../utils/util");
var types_1 = require("../../configuration/types");
/**
 * OUI modal component.
 *
 * @oui-component Modal
 */
var Modal = function (_a) {
    var children = _a.children, closeHandler = _a.closeHandler, closeDisabled = _a.closeDisabled, closeLinkText = _a.closeLinkText, footerContent = _a.footerContent, userPortalClass = _a.portalClass, helpLink = _a.helpLink, isOpen = _a.isOpen, testId = _a.testId, title = _a.title;
    var containerRef = React.createRef();
    var keyupHandler = React.useCallback(function (event) {
        if (closeDisabled)
            return;
        if (["Escape", "Esc"].includes(event.key)) {
            event.stopPropagation();
            closeHandler && closeHandler();
        }
    }, [closeDisabled, closeHandler]);
    // listen to KeyUp to to allow child DatePicker, TreeSelect and RichSelect components to close on KeyDown and not propagate to modal
    React.useEffect(function () {
        var container = containerRef && containerRef.current;
        if (!container)
            return;
        isOpen && container.addEventListener("keyup", keyupHandler);
        return function () {
            container.removeEventListener("keyup", keyupHandler);
        };
    }, [keyupHandler, isOpen, containerRef.current]);
    if (!isOpen) {
        return null;
    }
    var headerId = util_1.uniqueGUID();
    return (React.createElement(types_1.OuiConfigurationContextConsumer, null, function (_a) {
        var portalClass = _a.portalClass;
        return (React.createElement(__1.Portal, null,
            React.createElement("div", { className: userPortalClass || portalClass },
                React.createElement(FocusTrap_1.default, null,
                    React.createElement(react_remove_scroll_1.RemoveScroll, null,
                        React.createElement("div", { className: "oui-modal oui-open oui-display-block", role: Aria_1.Roles.Dialog, "aria-modal": "true", "aria-labelledby": headerId, "data-test-id": testId, ref: containerRef },
                            React.createElement("div", { className: "oui-modal-dialog oui-border-all oui-border-radius-all" },
                                React.createElement("div", { className: "oui-modal-header oui-flex oui-flex-middle" },
                                    React.createElement("h2", { className: "oui-modal-title oui-margin-remove-bottom oui-flex-1", id: headerId }, title),
                                    React.createElement("div", { className: "oui-overflow-hidden" },
                                        helpLink && (React.createElement("span", { className: "oui-modal-header-help-link" },
                                            React.createElement(__1.Link, { href: helpLink, openInNewWindow: true, textStyle: __1.LinkTextStyle.None }, Messages.Common.help()))),
                                        closeHandler && (React.createElement("span", { className: "oui-modal-header-close-link" },
                                            React.createElement(__1.Button, { type: __1.ButtonType.Button, onClick: closeHandler, buttonStyle: __1.ButtonStyle.Link }, closeLinkText || Messages.Common.close()))))),
                                React.createElement("div", { className: "oui-modal-body" }, children),
                                footerContent && (React.createElement("div", { className: "oui-modal-footer" }, footerContent)))))))));
    }));
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map